import { Check, Minus } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.ts';

/**
 * Checkbox (DESIGN `components.checkbox`, shadcn-Aufbau): echter `button` mit `role="checkbox"` und
 * `aria-checked`. Rand `checkbox-line` (≥ 3 : 1), angehakt = Fläche TILL-Dunkelblau mit Haken (Change 03.10.2026 Design E · final). Leertaste und Klick schalten um.
 * Story 5.101: `checked="mixed"` = Teilzustand (Kopf-Häkchen, einige Zeilen angehakt; `aria-checked="mixed"`, Strich statt
 * Haken); ein Klick meldet dann `true` (alle anhaken).
 */
export function Checkbox({
  checked,
  onCheckedChange,
  className,
  disabled,
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'role' | 'type'> & {
  checked: boolean | 'mixed';
  onCheckedChange: (checked: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onCheckedChange(checked !== true);
      }}
      className={cn(
        'inline-flex size-check-size shrink-0 cursor-pointer items-center justify-center rounded-check border-[1.5px] transition-colors disabled:cursor-default disabled:opacity-50',
        checked !== false ? 'border-brand bg-brand text-on-brand' : 'border-checkbox-line bg-card',
        className,
      )}
      {...props}
    >
      {/* Haken ohne Zeigerereignisse: sonst trifft ein Klick auf den Haken das SVG, und ein umschließendes `<label>`
          leitet den Klick zusätzlich an den Knopf weiter – zweimal umgeschaltet, das Häkchen bliebe gesetzt. */}
      {checked === 'mixed' ? (
        <Minus size={13} strokeWidth={2.5} aria-hidden className="pointer-events-none" />
      ) : checked ? (
        <Check size={13} strokeWidth={2.5} aria-hidden className="pointer-events-none" />
      ) : null}
    </button>
  );
}
